// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"574344fc","736":"936dd16f","739":"e7b701df","816":"5b6e679b","986":"fc7cedbb"}[chunkId] + ".chunk.css";
};